import { render } from "./CreateUser.vue?vue&type=template&id=d8109b0a&ts=true"
import script from "./CreateUser.vue?vue&type=script&lang=ts"
export * from "./CreateUser.vue?vue&type=script&lang=ts"

import "./CreateUser.vue?vue&type=style&index=0&id=d8109b0a&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__